module.exports = __webpack_public_path__ + "static/media/mobile_screen.fa9f5c0b.png";